export default __webpack_public_path__ + "static/media/sports.0453a6d5.png";